import { Button,Input } from '@material-ui/core'
import { Label } from '@material-ui/icons'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import firebase from 'firebase'
import './Chat.css'
import {NavBar} from '../navBar/NavBar'


export const Login =() => {
    const history = useHistory()
    const [userInfo, setUserInfo] = useState({ nickname: '' })
    const ref = firebase.database().ref('chatusers/')

    const handleonChange = (evt) => {
        evt.persist()
        setUserInfo({...userInfo, [evt.target.name]: evt.target.value})
    }

    const chatUserLogin = (evt) => {
        evt.preventDefault()
        ref.orderByChild('nickname').equalTo(userInfo.nickname).once('value', snapshot => {
            if (snapshot.exists()) {
                localStorage.setItem('nickname', userInfo.nickname)
                history.push('/roomlist')
            } else {
                const newUser = firebase.database().ref('chatusers/').push()
                newUser.set(userInfo)
                localStorage.setItem('nickname', userInfo.nickname)
                history.push('/roomlist')
            }
        })
    }

    return (
        <div className = 'chat__login__screen__container'>
        <NavBar />
        <p id = 'nickname__rule'>To join a chat room, please enter a  username. 
        <br />This can be your public name, or if you prefer to stay anonyomous,
        <br /> you can use 'anon' or select a different nickname.</p>
        <div id = 'chat__login__container'>
        <Label>Nickname</Label>
        <Input type='text' name='nickname' placeholder='Please enter a nickname' value={userInfo.nickname} onChange={handleonChange} />
            <Button variant='primary' type='submit' onClick = {chatUserLogin}>
                Login
            </Button> 
        </div>
        </div>
    )

}
